import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Ticket/Step5Ticket.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import getCookie from "../../api";
import { ToWords } from "to-words";
import { toast, ToastContainer } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axiosInstance from "../../api";

function Step5Ticket({ setCatchStep, enquiryId }) {
  const { quotationId } = useParams();
  setCatchStep(useLocation().pathname.split("/")[4].trim());

  const [enquiryData, setEnquiryData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [quotationItemsData, setQuotationItemsData] = useState([]);
  const [partItemsData, setPartItemsData] = useState([]);
  const [emailloading, setEmailloading] = useState(false);
  const invoiceref = useRef();
  const nav = useNavigate();
  const toWords = new ToWords({
    localeCode: "en-IN",
  });

  useEffect(() => {
    axiosInstance
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/api/v1/NewEnquiry/GetEnquiryById?seriesId=${encodeURIComponent(
          enquiryId
        )}`
      )
      .then((res) => {
        getCompanyInfo(res.data.companyId).then((resp) => {
          setEnquiryData({ ...res.data, companyName: resp });
        });
      })
      .catch(console.log);
  }, [enquiryId]);

  function getCompanyInfo(id) {
    return axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Customer/GetCustomerByIdOrName?id=${id}`
      )
      .then((res) => res.data[0].orgName)
      .catch((err) => "");
  }

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Invoice/GetByQuotationId/${quotationId}`
      )
      .then((res) => {
        setInvoiceData(res.data);
        if (res.data?.quotation?.enquiryType === "Parts")
          getPartsItemDataByQuotationId(res.data?.quotation?.id);
        else getQuotationItemsByQuotationId(res.data?.quotation?.id);
      })
      .catch(console.log);
  }, [quotationId]);

  function getQuotationItemsByQuotationId(id) {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/QuotationItems/${id}`)
      .then((res) => {
        setQuotationItemsData(res.data);
      })
      .catch(console.log);
  }

  function getPartsItemDataByQuotationId(id) {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/PartItems/${id}`)
      .then((res) => {
        setPartItemsData(res.data);
      })
      .catch(console.log);
  }

  return (
    <section className="step5-ticket" ref={invoiceref}>
      <h1>{enquiryData?.enquiryType?.toUpperCase()} INVOICE</h1>
      <blockquote id="printandEmailInvoice">
        <i
          className="fa-solid fa-arrow-left"
          title="Go To Previous Page"
          onClick={() => nav(-1)}
        ></i>
        {/*emailloading ? (
          <i class="fa-solid fa-arrows-spin fa-spin"></i>
        ) : (
          <i
            className="fa-solid fa-envelope"
            onClick={() => {
              setEmailloading(true);
              html2canvas(invoiceref.current).then((canvas) => {
                axiosInstance
                  .post(
                    `${process.env.REACT_APP_API_URL}/api/SendEmail/SendMail`,
                    {
                      To: enquiryData?.customerEmail,
                      Base64String: canvas.toDataURL("image/png"),
                    }
                  )
                  .then((res) => {
                    toast.success(res.data, {
                      position: "bottom-center",
                      theme: "dark",
                    });
                    setEmailloading(false);
                  })
                  .catch((err) => {
                    toast.error("Failed to Send Mail", {
                      position: "bottom-center",
                      theme: "dark",
                    });
                    setEmailloading(false);
                  });
              });
            }}
          ></i>
        )*/}

        <i className="fa-solid fa-print" onClick={() => window.print()}></i>
        <i
          className="fa-solid fa-download"
          onClick={() => {
            const icons = document.getElementById("printandEmailInvoice");
            icons.style.display = "none";
            html2canvas(invoiceref.current).then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF("p", "mm", "a4");

              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = pdf.internal.pageSize.getHeight();

              const bottomPadding = 10;
              const usableHeight = pdfHeight - bottomPadding;

              const imgWidth = pdfWidth;
              const imgHeight = (canvas.height * imgWidth) / canvas.width;

              let heightLeft = imgHeight;
              let position = 0;

              pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
              heightLeft -= usableHeight;

              while (heightLeft > 0) {
                position -= usableHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= usableHeight;
              }

              pdf.save(
                "Invoice_" +
                  enquiryData.seriesID
                    .replace("-", "")
                    .replace("SE", "")
                    .replace("PE", "")
              );
              icons.style.display = "flex";
            });
          }}
        ></i>
      </blockquote>
      <section>
        <div>
          <aside>
            <blockquote>
              <h3>ROSS BOILERS (2025-26)</h3>
              <p>33, BURHANI INDL. ESTATE</p>
              <p>KONDHWA BK.</p>
              <p>PUNE - 411048</p>
              <p>MSME NO. MH-26-0239197</p>
              <p>GSTIN/UIN: 27ADFPS7985L1ZJ</p>
              <p>State Name: Maharashtra, Code : 27</p>
            </blockquote>
            {enquiryData && (
              <>
                <dl>
                  <dd>
                    <p>Invoice No.</p>
                    <b>{invoiceData?.invoiceNumber}</b>
                  </dd>
                  <dd>
                    <p>Dated</p>
                    <b>{new Date(invoiceData?.createdDate).toDateString()}</b>
                  </dd>
                  <dd>
                    <p>Payment Mode</p>
                    <b>{invoiceData?.paymentMode}</b>
                  </dd>
                  <dd>
                    <p>Buyer's Order No.</p>
                    <b>{invoiceData?.buyersOrderNumber}</b>
                  </dd>
                </dl>
                <blockquote
                  style={{ gridColumn: enquiryData.isAddressSame && "span 2" }}
                >
                  <p>
                    Consignee (
                    {enquiryData.isAddressSame
                      ? "Ship To / Bill To"
                      : "Ship To"}
                    )
                  </p>
                  <h3>{enquiryData.customer.orgName}</h3>
                  <p>
                    {enquiryData.shipToAddress.officeName ||
                      enquiryData.shipToAddress.factoryName}
                    , {enquiryData.shipToAddress.address1},{" "}
                    {enquiryData.shipToAddress.address2},{" "}
                    {enquiryData.shipToAddress?.cityObj?.name ||
                      enquiryData.shipToAddress?.cityName}
                    ,{" "}
                    {enquiryData.shipToAddress?.stateObj?.name ||
                      enquiryData.shipToAddress?.stateName}
                    , {enquiryData.shipToAddress.country},{" "}
                    {enquiryData.shipToAddress.pincode}
                  </p>
                  <ul>
                    <li>GSTIN/UIN : {enquiryData.customer.gstNumber}</li>
                    <li>Contact Person : {enquiryData.contactCentre.name}</li>
                    <li>
                      Phone Number : {enquiryData.contactCentre.phoneNumber}
                    </li>
                    <li>Contact Email: {enquiryData.contactCentre.email}</li>
                  </ul>
                </blockquote>
                {enquiryData.isAddressSame === false && (
                  <blockquote>
                    <p>Buyer (Bill To)</p>
                    <h3>{enquiryData.customer.orgName}</h3>
                    <p>
                      {enquiryData.billToAddress.officeName ||
                        enquiryData.shipToAddress.factoryName}
                      , {enquiryData.billToAddress.address1},{" "}
                      {enquiryData.billToAddress.address2}
                      {enquiryData.billToAddress?.cityObj?.name ||
                        enquiryData.billToAddress?.cityName}
                      ,{" "}
                      {enquiryData.billToAddress?.stateObj?.name ||
                        enquiryData.billToAddress?.stateName}
                      {enquiryData.billToAddress.country},{" "}
                      {enquiryData.billToAddress.pincode}
                    </p>
                    <ul>
                      <li>GSTIN/UIN : {enquiryData.customer.gstNumber}</li>
                      <li>Contact Person : {enquiryData.contactCentre.name}</li>
                      <li>
                        Phone Number : {enquiryData.contactCentre.phoneNumber}
                      </li>
                      <li>Contact Email: {enquiryData.contactCentre.email}</li>
                    </ul>
                  </blockquote>
                )}
              </>
            )}
          </aside>
        </div>
        <main>
          {enquiryData?.enquiryType === "Parts" ? (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Sr.No.</th>
                    <th>Part Number</th>
                    <th>Part Name</th>
                    <th>HSN Code</th>
                    <th>Quantity</th>
                    <th>Price Per Part ({invoiceData?.quotation?.symbol})</th>
                    <th>Amount ({invoiceData?.quotation?.symbol})</th>
                  </tr>
                </thead>
                <tbody>
                  {partItemsData.length > 0 &&
                    partItemsData.map((x, sr) => (
                      <tr>
                        <td>{sr + 1}</td>
                        <td>{x.partNumber}</td>
                        <td>{x.partName}</td>
                        <td>{x.hsnCode || ""}</td>
                        <td>{x.quantity}</td>
                        <td>{x.rate}</td>
                        <td>{Math.round(x.amount)}</td>
                      </tr>
                    ))}
                  <tr>
                    <td colSpan={6}>SubTotal</td>
                    <td>
                      <b>{Math.round(invoiceData?.quotation?.subTotal)}</b>
                    </td>
                  </tr>

                  {invoiceData?.quotation?.packingForwarding !== 0.0 && (
                    <tr>
                      <td colSpan={6}>Packaging and Forwarding</td>

                      <td>
                        <p>
                          {Math.round(
                            invoiceData?.quotation?.packingForwarding
                          )}
                        </p>
                      </td>
                    </tr>
                  )}
                  {invoiceData?.quotation?.courierExp !== 0.0 && (
                    <tr>
                      <td colSpan={6}>Transport/Courier Charges</td>

                      <td>
                        <p>{Math.round(invoiceData?.quotation?.courierExp)}</p>
                      </td>
                    </tr>
                  )}

                  {invoiceData?.quotation?.discountPercentage !== 0 && (
                    <tr>
                      <td colSpan={6}>
                        Discount {invoiceData?.quotation?.discountPercentage}%
                      </td>

                      <td>
                        <p>
                          {Math.round(invoiceData?.quotation?.discountValue)}
                        </p>
                      </td>
                    </tr>
                  )}
                  {(invoiceData?.quotation?.packingForwarding !== 0.0 ||
                    invoiceData?.quotation?.courierExp !== 0.0 ||
                    invoiceData?.quotation?.discountPercentage !== 0) && (
                    <tr>
                      <td colSpan={6}>Final Total</td>
                      <td>
                        <b>{Math.round(invoiceData?.quotation?.finalTotal)}</b>
                      </td>
                    </tr>
                  )}
                  {invoiceData?.quotation?.gstPercentage !== 0 && (
                    <tr>
                      <td colSpan={6}>
                        GST {invoiceData?.quotation?.gstPercentage}%
                      </td>

                      <td>
                        <p>{Math.round(invoiceData?.quotation?.gstAmount)}</p>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={6}>Grand Total</td>

                    <td>
                      <b>{Math.round(invoiceData?.quotation?.grandTotal)}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Description of Goods</th>

                    <th>Price Per Day ({invoiceData?.quotation?.symbol})</th>
                    <th>Number of Days</th>
                    <th>Total ({invoiceData?.quotation?.symbol})</th>
                  </tr>
                </thead>

                <tbody>
                  {quotationItemsData.length > 0 &&
                    quotationItemsData.map((x, sr) => (
                      <tr>
                        <td>{sr + 1}</td>
                        <td>{x.description}</td>

                        <td>{x.pricePerDay}</td>
                        <td>{x.noOfDays}</td>
                        <td>{Math.round(x.total)}</td>
                      </tr>
                    ))}
                  <tr>
                    <td colSpan={4}>SubTotal</td>
                    <td>
                      <b>{Math.round(invoiceData?.quotation?.subTotal)}</b>
                    </td>
                  </tr>

                  {invoiceData?.quotation?.discountPercentage !== 0 && (
                    <>
                      <tr>
                        <td colSpan={4}>
                          Discount {invoiceData?.quotation?.discountPercentage}%
                        </td>

                        <td>
                          <p>
                            {Math.round(invoiceData?.quotation?.discountValue)}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4}>Final Total</td>
                        <td>
                          <b>
                            {Math.round(invoiceData?.quotation?.finalTotal)}
                          </b>
                        </td>
                      </tr>
                    </>
                  )}
                  {invoiceData?.quotation?.gstPercentage !== 0 && (
                    <tr>
                      <td colSpan={4}>
                        GST {invoiceData?.quotation?.gstPercentage}%
                      </td>

                      <td>
                        <p>{Math.round(invoiceData?.quotation?.gstAmount)}</p>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={4}>Grand Total</td>
                    <td>
                      <b>{Math.round(invoiceData?.quotation?.grandTotal)}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <aside>
            <blockquote style={{ flexDirection: "row" }}>
              <p>Amount Chargeable (in words) </p>
              <p>E.& O.E :</p>
              <b>
                {toWords.convert(
                  Math.round(invoiceData?.quotation?.grandTotal || 0)
                )}{" "}
                {invoiceData?.quotation?.symbol === "INR"
                  ? "Only"
                  : invoiceData?.quotation?.symbol}
              </b>
            </blockquote>
          </aside>
        </main>
        <aside>
          <div>
            <blockquote>
              <p>
                for <strong>ROSS BOILERS (2025-26)</strong>
              </p>

              <p style={{ marginTop: "1.5rem" }}>________________________</p>
              <p>Authorized Signature</p>
            </blockquote>
          </div>
        </aside>
      </section>
      <aside id="InvoiceCertificationsInStep5">
        <img src="/images/5000-satisfied.png" />
        <img src="/images/IBR-CERTIFIED.png" />
        <img src="/images/ISO-9001-2015.png" />
      </aside>
    </section>
  );
}

export default Step5Ticket;
